// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"7b7195a3","910":"45b5b120"}[chunkId] + ".chunk.css";
};